import styles from './StepProgress.module.css'
import { StepDef } from '../../components/MultiForm/wizardSteps'

type StepProgressProps = {
  steps: StepDef[]
  currentIndex: number
}

function StepProgress({ steps, currentIndex }: StepProgressProps) {
  return (
    <div className={styles.container}>
      {steps.map((s, i) => {
        const completed = i < currentIndex
        const active = i === currentIndex

        return (
          <div key={i} className={styles.stepWrapper}>
            {i > 0 && (
              <div
                className={`${styles.line} ${
                  i <= currentIndex ? styles.lineActive : ''
                }`}
              />
            )}
            <div
              className={`${styles.circle} ${
                completed ? styles.completed : ''
              } ${active ? styles.active : ''}`}
            >
              {completed ? (
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2 7L5.5 10.5L12 3.5"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ) : (
                <span className={styles.number}>{i + 1}</span>
              )}
            </div>
            <span
              className={`${styles.label} ${active ? styles.labelActive : ''} ${
                completed ? styles.labelCompleted : ''
              }`}
            >
              {s.label}
            </span>
          </div>
        )
      })}
    </div>
  )
}

export { StepProgress }
